import React, { Fragment, useEffect, useState } from "react";
import styles from "./scss/savedchats.module.scss";
import { Modal, Select, Tooltip } from 'antd';
import AudioPlayer, { RHAP_UI } from 'react-h5-audio-player';
import { URAvatarGroup } from "../../../shared/widgets/avatarGroup";
import { useSelector } from "react-redux";
import { chats, chatwindowDetails, initialStateModel, LoginState, recentChatSocketReducerStateModel } from "../../../models/model";
import moment from "moment";
import { ChatService } from "../../../base/chatService";
import { complete_event_status, getcontactDetail, urlify, getFileSize, getTooltipTime } from "../../../base/utils";
import { StatusTag } from "../../../shared/widgets/statusTag";
import eventimg from "../../../styles/images/eventsvg.svg";
import notesimg from "../../../styles/images/notessvg.svg";
import taskimg from "../../../styles/images/tasksvg.svg";
import usercircle from "../../../styles/images/user-circle.svg";
import iconpdf from "../../../styles/images/grid_pdf.svg";
import iconppt from "../../../styles/images/grid_ppt.svg";
import iconword from "../../../styles/images/grid_word.svg";
import iconxls from "../../../styles/images/grid_xls.svg";
import iconzip from "../../../styles/images/grid_zip.svg";
import arrowlink from "../../../styles/images/viewarrow.svg";
import notSupported from "../../../styles/images/hiddenimage.svg";
import iconotherformat from "../../../styles/images/otherformat.svg";
import { PriorityBeam } from "../../../shared/widgets/priorityBeam";
import ChatAttachmentsOption from "../chatWidgets/chatAttachmentOption";
import { excelFormats, pptFormats, wordFormats, zipFormats,
  mp3Formats, pdfFormats, imageFormat, videoFormat,SearchFilter} from "../../../base/utils";
import store from "../../../context/store/store";
import { SocketChatService } from "../../../base/socketChatService";
import { generateChatID, userInfo } from "../../../base/socketChatService/utils";
import { useHistory } from "react-router-dom";
import _ from 'lodash';
import { URStatusDot } from "../../../shared/widgets/avatarGroup/statusDot";
import { userStatusColor } from "../../../base/callService/common";
import ChatRightInfo from "../chatWidgets/chatRightInfo";
import ChatUserInfo from "../chatWidgets/chatUserInfo";
import ChatAudioInner from "../chatWidgets/chatAudioInner";
import { Types } from "../../../context/action/action";
import FilePreview from "../chatWidgets/filePreview";
// type RecentChatState={
//   limit:any;
//   offset:any;
// }
type fileMessageState = {
  isOpen: boolean;
  id: any;
  dataRes: any;
}
export default function SavedChatListsLeft(props:any) {

  const contactList: recentChatSocketReducerStateModel = useSelector((state: initialStateModel) => state.chatSocketRecentReducerState);
  const loginDetails: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
  const chat_reducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  const chatWindowDetailReducer: chatwindowDetails = useSelector((state: initialStateModel) => state.chatWindowReducer);
  let { chatWindowDetails } = chatWindowDetailReducer;
  const [contactLists, setcontactLists] = useState<any>([]);
 // const socketService = useRef<any>(null);
 const {allContacs,allContacsLoading,teamContacsnew} =  useSelector((state: initialStateModel)=> 
 state.contactReducer);
 const [fileState, setfileState] = useState<fileMessageState>({ isOpen: false, id: '', dataRes: '' });
  const [longText, setlongtext] = useState(0);
  const [isSharedModalVisible,setSharedModalVisible] = useState<any>(false)
  const [shareContact, setshareContact] = useState<any>({
    contactList: allContacs, searchContactList:allContacs, contactDetail: [],
    selectedmember: [],selectedsavedMsg :{}
  });  
  // const chatReducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  //const [pagination, setPagination] =  useState<RecentChatState>({limit:40,offset:0});
  let { savedChatList } = contactList;
  let fileArr:any =   _.filter(savedChatList, function (o: any) {
    return o.message?.messageType === "FILE" && videoFormat.indexOf(o.message?.body?.fileType) !== -1;
  });
  
  const history = useHistory();
  useEffect(() => {
    if(props.defaultContacts.searchText !=="" ){
      let searchList= searchData(props.defaultContacts.searchText);
       setcontactLists(searchList);
    }
    else{
      setcontactLists(savedChatList);
    }
  }, [props.defaultContacts.searchText, savedChatList]);
  const searchData = (str: string) => {
    let searchText = str.toLowerCase();
  
    return _.filter(savedChatList, function (data: any) {

      let saveMessageBody = (data.message.messageType === "NOTE" || data.message.messageType === "TASK" || data.message.messageType === "EVENTS") ?
        data?.message?.body?.summary?.trim() : (data.message.messageType === "FILE" || data.message.messageType === "IMAGE") ?
          (data.message.body.fileName || "") :   data.message.messageType === "GEO" ?  "":
         data.message.body;

      let sender = data.fromDetails?.caller_id || '';
      let toTeam = (data.toDetails?.caller_id ? data.toDetails.caller_id : data.toDetails?.team_name) || '';
      let Datesearch = moment(new Date(parseInt(data.timestamp))).format("ddd, MMM Do YYYY") || '';
      return (((saveMessageBody).toLowerCase()).includes(searchText) ||
        (sender).toLowerCase().includes(searchText) || (toTeam).toLowerCase().includes(searchText) ||
        (Datesearch.toString()).toLowerCase().includes(searchText));
    });
  };
try{
  

  const onReply = (data: any) => {
    let contactskey = Object.keys(data.toDetails);
    if (contactskey.length === 1) { return; } 
    else {
    let to: any =  _.isEqual(data.toDetails, loginDetails.userdetails)
      ? data.fromDetails :data.toDetails; 
    ChatService.openChatWindow(to,history,data);
    ChatService.onChangeReplyWindow(true,data);
    }
  };

  const setFilteredLayer = ()=>{
    props.setFilteredLayer("default");
  };

  const UnsaveMessage=(data:any)=>{
    let isBookmark = {
      id:data.id,
      saveStatus:0
    };
    const socketChat = new SocketChatService(userInfo().fromID, userInfo().domainId);
    const timer = setTimeout(()=>{ socketChat.bookMarkMesseage(isBookmark);socketChat.toastUndo("","")},3000);
    socketChat.toastUndo("1 Message unsaved",timer);
  };

  const handleScroll=(e:any)=>{
    const bottom = e.target.scrollHeight - Math.round(e.target.scrollTop) === e.target.clientHeight;
    if(bottom  /* && isSavedPaginationStop */){
      // ChatService.recentSavedPagination(pagination.limit,pagination.offset);
      // setPagination({...pagination,limit:pagination.limit+20, offset:pagination.offset});
    }
  };

  const openPreview =()=>{
    
  };
  const FilePreviewer = ()=>{
    setfileState({...fileState,isOpen:!fileState.isOpen});
  };
  const previewopen = (data: any) => {
    setfileState({ ...fileState, isOpen: !fileState.isOpen, id: data?.id, dataRes: data });
  };

  let fileDetails:any ={};
  var resultDesc:any = _.orderBy(contactLists, ['timestamp'], ['desc']);
  let result: any = _(resultDesc)
  .groupBy((o: any) => (o.timestamp &&
      moment(o.timestamp).format('DD MMM YYYY')))
  .map((contacts: any, letter: any) => ({ letter, contacts }))
  .value();

  result.map((contactsList:any, i:any)=> {
  let pr_fromuser = "";
  let pr_touser = "";
  contactsList?.contacts?.map((list:any, k:any)=> {
    if(pr_fromuser !== list.from || pr_touser !== list.to){
      result[i].contacts[k].isHeader = true;
    }else{
      result[i].contacts[k].isHeader = false;
    }
    pr_fromuser = list.from;
    pr_touser = list.to;
  })
  })

  const viewinConversation = (list: any, contact: any) => {
    if(!_.isUndefined(contact)){
      let contactskey = Object.keys(contact);
    if (!_.isUndefined(contactskey)&&contactskey.length === 1) { return; } 
    else {
      var  chatService = new SocketChatService(userInfo().fromID, userInfo().domainId);
      if(chatWindowDetails?.sip_login_id !== contact?.sip_login_id || chatWindowDetails?.team_id !== contact?.team_id ){
      
        let chatDetail ={chatId:generateChatID(userInfo().fromID,contact?.sip_login_id?contact?.sip_login_id.toString() :contact?.team_id.toString())};
      chatService.openChatWindow(contact,history,chatDetail);
      }
      let dataRes:any = {chatId:list?.chatId,"id":list.id }
      chatService.Savehistory(dataRes);
      setTimeout(()=>{
        chatService.saveChatHighlight(true,list);
      }, 500)
      chat_reducer.isDelete  && ChatService.onChangeDeleteWindow(false,''); 
      chat_reducer.isForward && ChatService.onChangeForwardWindow(false,''); 
      ChatService.onChangeReplyWindow(false, "");
      if(contact?.sip_login_id === userInfo().fromID){
        ChatService.emptyOnMyspace();
        ChatService.editDraft("");
       
        store.dispatch({
          type: Types.TAB_CHANGE,
          payload: {
            ActiveTab: '1'
          }
        });
      }
      
    }
    }
 
  }

  const handleOk = () => {
    let tempArray =[];
    tempArray.push(shareContact.selectedsavedMsg);
    ChatService.forwardMessage(tempArray,shareContact.contactDetail);
    setshareContact({...shareContact,contactDetail :[],selectedmember:[]});
    setSharedModalVisible(false);
  };
  const handleCancel = () => {
    setSharedModalVisible(false);
  };

  const showModal = (data:any) => {
    setSharedModalVisible(true);
    setshareContact({...shareContact,contactDetail :[],selectedmember:[],selectedsavedMsg:data});
    }

    const onChangeSelectMembers =(member:any)=>{
      let {userdetails}:LoginState = store.getState().loginReducer;
      let contact:any=
      member.map((item:string,index:any)=>
      {
        return getcontactDetail(item.toString(),shareContact.contactList,userdetails);
      });
      setshareContact({
        ...shareContact, selectedmember: member,
        searchContactList: shareContact.contactList,contactDetail:contact
      });
    };

    const onSearchMembers = (value: any) => {
      let response = SearchFilter(shareContact.contactList, value.toLowerCase());
      setshareContact({ ...shareContact, searchContactList: response });
    };
    
    const readMoreChange = ()=>{
      setlongtext(1);
    }
   
    const openLink = (url: any) => {
      if (!url.includes("http")) url = "https://" + url;
      window.open(url);
    };
    let messageBody:any = (shareContact?.selectedsavedMsg.message?.messageType === 'IMAGE' || shareContact?.selectedsavedMsg.message?.messageType === 'FILE')?
    shareContact?.selectedsavedMsg.message.body:"";   
    let len = Math.ceil((shareContact?.searchContactList?.length / 8));
    let random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();
  return (
    <>
{fileState.isOpen && <FilePreview isOpen={fileState.isOpen} data={fileState.dataRes}
              previewopen={FilePreviewer}  groupdata={fileArr}/> }
      <div className={`fadeIn ${styles.savedchatmain}`}>
        <div className={styles.rightbartop}>
          <div className={styles.lefts}>
            Saved <b>{`(${savedChatList.length})`}</b>
          </div>
          <div className={styles.rights}>
            <Tooltip mouseEnterDelay={0.5}  placement="top" title="Close">
              <span className="icon_close" onClick={setFilteredLayer}></span></Tooltip>
          </div>
        </div>
        <div className={`${styles.rightbarbottom} ${"scrollerhover"}`} onScroll={handleScroll}>

              {result && result.map((contactsDetails: any, index: any) => {
                return(   
                  <Fragment key={index}>        
          {allContacsLoading && _.isArray(allContacs)&&allContacs.length>0 &&


          Array.isArray(contactsDetails?.contacts) && contactsDetails?.contacts?.map((save:any, i:any)=> {
            let redirectUsr:any = loginDetails?.userdetails?.sip_login_id === save?.to ? save?.fromDetails : save?.toDetails ;            
           let mstext:any = save?.message?.body;
            if (mstext?.length > 200 && longText === 0) {
              mstext = mstext.substring(0, 200) + "...";
            }
        
            let from:any = save?.fromDetails && save?.fromDetails?.caller_id?.length <= 15 ? save?.fromDetails?.caller_id : save?.fromDetails?.caller_id?.substring(0, 15) + "...";
            let to:any = save?.toDetails?.team_id ? save?.toDetails?.team_name : save?.toDetails?.caller_id !== undefined?  save?.toDetails?.caller_id: 'Unknown User';
           let teamMemberOnly =
           save?.toDetails?.team_members && save?.toDetails?.team_members
             ? save?.toDetails?.team_members.split(",").map((ele: any) => ele.trim())
             : [];
            let isCloudfiles = false;
             if(save.message.messageType === "FILE" || save.message.messageType === "IMAGE"){
              fileDetails = save?.message?.body;
              isCloudfiles = fileDetails?.isCloudfiles|| false;
            } 
            let leaveMem:boolean = save?.toDetails?.team_id ? teamMemberOnly.includes(loginDetails?.userdetails?.sip_login_id.toString().trim()) : true
            let currentDate = getTooltipTime(save.timestamp)
  
            return (
              <>
                <div className={`${styles.savedchatlist }`} onClick={()=>viewinConversation(save,redirectUsr)} >

                  {save.isHeader ?(
                  <div className={styles.toplayer}>
                            <h3>
                              {loginDetails.userdetails?.caller_id === save?.fromDetails?.caller_id
                                ? "You" : save?.fromDetails?.caller_id !== undefined? from :'Unknown User'}
                                <span className="icon_strokearrowright"></span>

                                <b>{loginDetails.userdetails?.caller_id === save?.toDetails?.caller_id ?
                                  "You" : to?.length > 20 ?  (to?.substring(0, 20) + "..."): to}</b>

                                <span className={styles.dates}>{moment(save?.timestamp).format("D MMM")}</span>
                              </h3>

                    </div>
                  ):null}

                 

                  <div className={styles.topbottomlayer} >
                    <div className={styles.lefts}>
                      <span className="icon_ribbon"></span><br />
                      <Tooltip mouseEnterDelay={0.5}  placement="top" title={currentDate} >
                          <span className={styles.timeHover}>
                          {moment(save?.timestamp).format('hh:mm')}
                          </span>
                        </Tooltip>
                    </div>
                    <div className={styles.hoverdiv} onClick={(e:any) => e.stopPropagation()}>
                      <ul>
                        <li onClick={()=>UnsaveMessage(save)}>
                          <Tooltip mouseEnterDelay={0.5}  placement="top" title="Remove from Saved Chats">
                            <span className="icon_savechatsill"></span></Tooltip></li>
                        {leaveMem &&(save?.message?.messageType === "FILE" || save?.message?.messageType === "TEXT" ||save?.message?.messageType === "IMAGE")
                       &&<li onClick={()=>onReply(save)}>
                         <Tooltip  mouseEnterDelay={0.5}  placement="top" title="Reply"><span className="icon_chat"></span></Tooltip></li>}
                      
                         
                         {(save?.message?.messageType === "FILE" || save?.message?.messageType === "TEXT" ||save?.message?.messageType === "IMAGE")
                         &&<li><Tooltip mouseEnterDelay={0.5}  placement="top" title="Share">
                          <span className="icon_reply" onClick={()=>showModal(save)}></span></Tooltip></li>}
                      </ul>
                    </div>
                    {save?.message?.messageType === "NOTE" ? <>
                      <div className={styles.noteshort} onClick={()=>viewinConversation(save,redirectUsr)}>
                        <img src={notesimg} alt=""/>
                        <div className={styles.filesDetails}>
                          <span className={styles.fileName}>
                          { save.message.body.summary}
                          </span>
                          <span className={styles.fileDt}>Created on {save.message.body.lastModified
                          && moment(new Date(parseInt(save.message.body.lastModified))).format('ll')}</span>
                        </div>
                      </div>
                    </>:save?.message?.messageType === "TASK" ? <>
                      <div className={`className ${styles.taskMessage}`} onClick={()=>viewinConversation(save,redirectUsr)}>
                        <span className={styles.taskCreated}><img src={taskimg} alt="" /></span>
                        <div className={styles.taskHeader}>
                          <div className={styles.taskStatus}>
                            <span className={styles.taskTitle}>{save?.message?.body?.summary}</span>
                            {save?.message?.body?.attendee.length > 0 &&
                            <span className={styles.userCount}>{save?.message?.body?.attendee.length}
                              <img src={usercircle} alt="" /></span>}
                          </div>
                          <div className={styles.taskDetails}>
                            <PriorityBeam className='priorityBeam bgGrey'/>
                            <span className={styles.taskDate}>
                              {moment(new Date(parseInt(save?.message?.body?.dtend)*1000)).format("ll")}</span>
                         
                          <div className={styles.reviewBtn}>
                            {save?.message?.body?.taskStatus=== "In Review" ||
                            save?.message?.body?.reporter_status=== "In Review" ?
                              <StatusTag className='statusunderReview' name='In Review' />
                              : save?.message?.body?.taskStatus=== "On Hold" ||
                              save?.message?.body?.reporter_status=== "On Hold" ?
                                <StatusTag className='statusHold' name='On Hold' />:
                                save?.message?.body?.taskStatus=== "Completed" ||
                                save?.message?.body?.reporter_status=== "Completed"?
                                  <StatusTag className='statusCompleted' name='Completed' />:
                                  <StatusTag className='statusunderinProgress' name='In Progress' />
                            }
                          </div>
                          </div>
                        </div>
                      </div>
                    </> : save?.message?.messageType === "EVENTS"?<>
                      <div className={styles.eventsMessage} onClick={()=>viewinConversation(save,redirectUsr)}>
                        <span className={styles.eventsCreated}><img src={eventimg} alt="" /></span>
                        <div className={styles.eventsHeader}>
                          <div className={styles.eventsStatus}>
                            <span className={styles.eventsTitle}>{save?.message?.body.summary}</span>
                          </div>
                          <div className={styles.eventsDetails}>
                          
                          </div>
                              <div className={styles.reviewBtn}>
                              <span className={styles.eventsDate}>
                              {moment(new Date(parseInt(save?.message?.body?.dtstart)*1000)).format("MMM Do YYYY")}</span>
                              {complete_event_status((save?.message?.body?.dtstart)*1000, (save?.message?.body?.dtend)*1000)
                                === "Completed" ?
                                  <StatusTag className='statusCompleted' name="Completed" />:
                                  complete_event_status((save?.message?.body.dtstart)*1000, (save?.message?.body?.dtend)*1000)
                                === "Yet To start"?
                                    <StatusTag className='statusyettoStart' name="Yet To start" /> :
                                    complete_event_status((save?.message?.body?.dtstart)*1000, (save?.message?.body?.dtend)*1000)
                                  === "In Progress"&&
                                  <StatusTag className='statusunderinProgress' name="In Progress"/>
                              }
                        
                          </div>
                        </div>
                      </div>
                    </>: (save?.message?.messageType === "FILE" || save?.message?.messageType === "IMAGE") && videoFormat.indexOf(fileDetails?.fileType) !== -1 && !isCloudfiles ?<>
                      <div className={styles.imageChat}>
                        <div className={styles.imageList}>
                          <div className={styles.imageSec}  onClick={()=>viewinConversation(save,redirectUsr)}>
                         
                            <video className="videoFluid"  controls={false} autoPlay={false} preload="metadata" >
                            <source src={fileDetails?.filePath} type="video/mp4" />
          <div className={styles.videoOverlay}></div>
        </video>
        <div className={styles.playIcon}
         onClick={()=>previewopen(save)}
        >
        </div>
                    </div>
                        </div>
                      </div>
                    </> : (save?.message?.messageType === "FILE" || (save?.message?.messageType === "IMAGE" && save?.message?.isLink !== true)) && imageFormat.indexOf(fileDetails?.fileType) !== -1 && !isCloudfiles ?<>
                      <div className={styles.imageChat}>
                        <div className={styles.imageList}>
                          <div className={styles.imageSec}>
                            <img src={fileDetails?.filePath} alt="" onClick={()=>viewinConversation(save,redirectUsr)}/></div>
                          </div>
                      </div>
                    </>
                    : (  save?.message?.messageType === "IMAGE" && save?.message?.isLink === true) && imageFormat.indexOf(fileDetails?.fileType) !== -1 && !isCloudfiles?<>
                    <div className={styles.imageChat}>
                      <div className={styles.imageList}>
                        <div className={styles.imageSec}>
                          <img src={fileDetails?.filePath} alt="" onClick={()=>viewinConversation(save,redirectUsr)}/></div>
                      </div>
                      <p  className={styles.linkText} onClick={() => openLink(save?.message?.body && save?.message?.body?.body)} 
                      dangerouslySetInnerHTML={{ __html: urlify(save?.message?.body) }}>
                                          </p>
                    </div>
                    </>: (save?.message?.messageType === "FILE" || save?.message?.messageType === "IMAGE")&& mp3Formats.indexOf(fileDetails?.fileType) !== -1 && !isCloudfiles ? <>
                      {/* <div className={styles.savedChatContent}>shared a audio</div> */}
                      <div className={styles.audioChat} onClick={()=>viewinConversation(save,redirectUsr)}>
                        <div className={styles.audioImage}>
                          {/* <div className={styles.convIcon}> */}
                          <URAvatarGroup className='lefts size38'
                              profileInfo={  save.fromDetails?.ImageURL ? 
                                              save.fromDetails?.ImageURL !== ""  ? 
                                                  <> <img src={ save.fromDetails?.ImageURL} alt="" />  </>
                                                  : <>  <span>{save.fromDetails?.caller_id?.charAt(0).toUpperCase()} </span>  </>
                                                  : 
                                                  save.fromDetails?.profile_url !== ""  ?
                                                  <> <img src={ save.fromDetails?.profile_url} alt="" />
                                                  </>
                                                  : <> <span>{save.fromDetails?.caller_id?.charAt(0).toUpperCase()} </span>
         </>} /> 
                          {/* </div> */}
                          
                        </div>
                        <div className={styles.audioDetails} >
                          <div className="audioNew">
                            <AudioPlayer
                              src={fileDetails?.filePath}
                              customIcons={{
                                play: <span className="icon_play"></span>,
                                pause: <span className="icon_pausebar"></span>
                              }}
                              customProgressBarSection={
                                [
                                  RHAP_UI.MAIN_CONTROLS,
                                  RHAP_UI.PROGRESS_BAR
                            
                                ]
                              }
                              customControlsSection={
                                [
                                  <div key={i}>Audio</div>,
                                  RHAP_UI.DURATION
                                ]
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </>: (save?.message?.messageType === "FILE" || save?.message?.messageType === "IMAGE") && imageFormat.indexOf(fileDetails?.fileType) === -1
                    && videoFormat.indexOf(fileDetails?.fileType) === -1 &&
       mp3Formats.indexOf(fileDetails?.fileType) === -1
      
                      ? <>
                        <div className={styles.chatAttachmentList}>
                         
                          {save?.message?.messageType === "FILE"&&
                          <div className={styles.filesChat} onClick={()=>viewinConversation(save,redirectUsr)}>
                            <div className={styles.filesImage}>
                              <img src={zipFormats.indexOf(fileDetails?.fileType) !== -1 ? iconzip :
                                pdfFormats.indexOf(fileDetails?.fileType) !== -1 ? iconpdf:
                                  wordFormats.indexOf(fileDetails?.fileType) !== -1 ? iconword:
                                    pptFormats.indexOf(fileDetails?.fileType) !== -1 ? iconppt:
                                      excelFormats.indexOf(fileDetails?.fileType) !== -1 ? iconxls :iconotherformat} alt="filename"/>
                              </div>
                            <div className={styles.filesDetails}>
                              <span className={styles.fileName}>{fileDetails?.fileName}</span>
                              <span className={styles.fileDt}>{getFileSize(fileDetails?.filesize)}</span>
                              {isCloudfiles && <span className={styles.fileDt}>{fileDetails.filePath.includes('https://app.box.com') ? ' Box'  : " Drive"}</span>}

                            </div>
                            {/* <div className={styles.attachmentHover} id={"hover"+save.id}><ChatAttachmentsOption data={fileDetails}
                              fromFiles={false}
                              previewopen={openPreview} hoverdata={fileDetails}/></div> */}
                          </div>}
                   
                        </div>
                      </>:
                                        (save.message?.isLink )?
                                        <div onClick={(e:any)=>viewinConversation(save,redirectUsr)} className={styles.savedChatLinks}>
                                          <span onClick={() => openLink(save?.message?.body)}  dangerouslySetInnerHTML={{ __html: urlify(save?.message?.body) }}></span>     
                                          
                                    </div> : 
                                    (save?.message?.messageType === "FILE" || save?.message?.messageType === "IMAGE") && (imageFormat.indexOf(fileDetails?.fileType) !== -1 || videoFormat.indexOf(fileDetails?.fileType) !== -1 || mp3Formats.indexOf(fileDetails?.fileType) !== -1) && isCloudfiles ?
                                    <div className={styles.chatAttachmentList}>
                                       <div className={styles.filesChat} onClick={()=>viewinConversation(save,redirectUsr)}>
                                      <div className={styles.filesImage}>
                                        <img src={notSupported} alt="filename"/>
                                        </div>
                                      <div className={styles.filesDetails}>
                                        <span className={styles.fileName}>{fileDetails?.fileName}</span>
                                        <span className={styles.fileDt}>{getFileSize(fileDetails?.filesize)}</span>
                                        {isCloudfiles && <span className={styles.fileDt}>{fileDetails.filePath.includes('https://app.box.com') ? ' Box'  : " Drive"}</span>}
          
                                      </div>
                                      {/* <div className={styles.attachmentHover} id={"hover"+save.id}><ChatAttachmentsOption data={fileDetails}
                                        fromFiles={false}
                                        previewopen={openPreview} hoverdata={fileDetails}/></div> */}
                                    </div>
                             
                                  </div> :
                                      save.message.messageType === "GEO" ? 
                                      <p className={styles.contentTxt}> this is geoLocation Message type</p> :<>
                                   { mstext?.length > 200 && longText === 0 && 
                    <span className={styles.savedChatTxt}> 
                 <p className={styles.contentTxt}>{mstext}
                    {mstext?.length > 200 && longText === 0 && <span className="chatReadMore" onClick={() => readMoreChange()}>Read more</span>}</p> 
                  </span> }
                  {(mstext?.length < 200 || longText === 1) && <p onClick={()=>viewinConversation(save,redirectUsr)} dangerouslySetInnerHTML={{ __html: mstext}}></p>}
                                      </>
                                          
                                       
                                         
                 
                                          }
                                             
                  </div>
                </div></>
            );
          })}
          </Fragment>
                )
              })}
          {/*  <div className={styles.savedchatlist}>
            <div className={styles.toplayer}>
              <URAvatarGroup className='lefts size38' profileInfo={<><span>D</span>
                <URStatusDot className='stsDotsm green'/></>}/>
              <h3>You <span className="icon_strokearrowright"></span> <b>Diana Bailey</b>
                <span className={styles.dates}>11 Aug</span> </h3>
            </div>
            <div className={styles.topbottomlayer}>
              <div className={styles.lefts}>
                <span className="icon_ribbon"></span><br/>12:20
              </div>
              <div className={styles.hoverdiv}>
                <ul>
                  <li><span className="icon_ribbon"></span></li>
                  <li><Tooltip placement="top" title="Reply"><span className="icon_chat"></span></Tooltip></li>
                  <li><span className="icon_reply"></span></li>
                </ul>
              </div>
              <p>We’ve invited you to the spreadsheet we did yesterday, but in case we
                will put it here for u guys me know, if everything seems to be clear for you.
                We can schedule the hangout meeting late, if you want.</p>
            </div>
          </div>

          <div className={styles.savedchatlist}>
            <div className={styles.toplayer}>
              <URAvatarGroup className='lefts size38 two' profileInfo={<><span>A</span><span>B</span></>}/>
              <h3>You <span className="icon_strokearrowright"></span> <b>Diana Bailey</b>
                <span className={styles.dates}>11 Aug</span> </h3>
            </div>
            <div className={styles.topbottomlayer}>
              <div className={styles.lefts}>
                <span className="icon_ribbon"></span><br/>12:20
              </div>
              <div className={styles.hoverdiv}>
                <ul>
                  <li><Tooltip placement="top" title="removed from saved items">
                    <span className="icon_savechatsill"></span></Tooltip></li>
                  <li><Tooltip placement="top" title="Reply"><span className="icon_chat"></span></Tooltip></li>
                  <li><span className="icon_reply"></span></li>
                </ul>
              </div>
              <p>We’ve invited you to the spreadsheet we did yesterday, but in case we will
                 put it here for u guys me know, if everything seems to be clear for you.
                  We can schedule the hangout meeting late, if you want.</p>
            </div>
          </div> */}
{/*           { savedPageLoad && ([1].map((item: any, index: any) => (
            <URChatLeftSkeleton width={100} key={index} />)))} */}
        </div>
      </div>
     
                   {isSharedModalVisible &&      <Modal title="Select Contact"
                          centered
                          visible={isSharedModalVisible}
                          onOk={shareContact.contactDetail.length > 0 ? handleOk : ()=>{}}
                          onCancel={handleCancel}
                          cancelText="Cancel"
                          okText="Share"
                          maskClosable={false}
                          cancelButtonProps={{ className: 'urButton buttonWhite' }}
                          okButtonProps={{ className: `urButton ${shareContact.contactDetail.length === 0 ? "disabled" : ""}` }}
                          className={`customPopup shareModel ${styles.newdeletechat}`} >
                      <div className={styles.shareSelect}>
          <Select
            mode="multiple"
            onChange={(data: any) => onChangeSelectMembers(data)}
            onSearch={onSearchMembers}
            style={{ width: '100%' }}
            filterOption={false}
            showSearch={true}
            value={shareContact.selectedmember}
            placeholder="Search Name/ Group/ Extension"
            className="createNewSel"
            dropdownClassName="newChatSel">
            { shareContact?.searchContactList?.map((contact:any,index:any)=>{
               
              let nameList= contact?.caller_id ?contact?.caller_id : contact?.team_name;
              return(
                <option key={index}
                  value={contact.sip_login_id?contact.sip_login_id: `con${contact.team_id}`}>
                  <div className="dropdowndesign">
                    <div className="usergroupss">
                      <URAvatarGroup className={`lefts size20 colorBG${random_color[index]}`} profileInfo={<>
                        {contact.ImageURL || contact.profile_image_url?
                          <><img alt="" src={contact.ImageURL?contact.ImageURL:contact.profile_image_url}/>
                            <URStatusDot
                              className={userStatusColor(contact?.user_status,'small')}/></>:
                          <span>{nameList?.charAt(0).toUpperCase()}<URStatusDot
                            className={userStatusColor(contact?.user_status,'small')}/></span>
                        }
                      </> } />
                    </div>
                    <div className="names">{nameList && nameList}</div>
                    {!contact.team_id && <div className="ext">{contact?.ext}</div>}
                  </div>
                </option>
              
              );
            })  
          }
         
          </Select>
        </div>
        { shareContact?.selectedsavedMsg?.message?.messageType === 'TEXT'
            &&
            <div className={`${styles.chatMsg} ${styles.rightMessage}`}>
              <div className={`${styles.chatUserDetails}`}>
                <ChatRightInfo userDetails = {shareContact?.selectedsavedMsg.fromDetails} isPopup={true}
                  timeStamp = {shareContact?.selectedsavedMsg.timestamp} message={shareContact?.selectedsavedMsg}></ChatRightInfo>
                <ChatUserInfo userDetails = {shareContact?.selectedsavedMsg.fromDetails} className='userinfoIcon rightSide'/>
              </div>
              <div className={styles.chatRightMessages}>
                <div className={styles.chatRight}>
                  <div className={styles.chatContent}>
                    <p>{shareContact?.selectedsavedMsg.message?.body}</p>
                    {/* <ChatLike className='likeRight' placement="topRight"
                      tooltipTitle={data?.likeduserdetails} message={data}/> */}
                  </div>
                </div>
              </div>
            </div>}
            {shareContact?.selectedsavedMsg?.message?.messageType === 'IMAGE' && imageFormat.indexOf(messageBody.fileType) !== -1 &&
            <div className={`${styles.chatMsg} ${styles.rightMessage}`}>
              <div className={`${styles.chatUserDetails}`}>
                <ChatRightInfo userDetails = {shareContact?.selectedsavedMsg?.fromDetails} isPopup={true}
                  timeStamp = {shareContact?.selectedsavedMsg?.timestamp} message={shareContact?.selectedsavedMsg}></ChatRightInfo>
                <ChatUserInfo userDetails = {shareContact?.selectedsavedMsg?.fromDetails} className='userinfoIcon rightSide'/>
              
              </div>
              <div className={styles.chatRightMessages}>
                <div className={styles.chatRight}>
                  <div className={styles.chatContent}>
                    <div className={styles.imageChat}>
                      <div className={styles.imageList}>
                      <div className={styles.imageSec}><img src={messageBody.filePath} alt=""/></div>
                      </div>
                    </div>
                    {/* <ChatLike className='likeRight' placement="topRight"
                      tooltipTitle={data?.likeduserdetails} message={data}/> */}
                  </div>
                  {/* <Tooltip title='Today at 12:13 PM' className='cusTooltip'
                    overlayClassName='customTooltip'><div className={styles.chatTime}>12:13</div></Tooltip> */}
                </div>
              </div>
            </div>}
            {shareContact?.selectedsavedMsg?.message?.messageType=== 'FILE' && videoFormat.indexOf(messageBody.fileType) !== -1 &&
            <div className={`${styles.chatMsg} ${styles.rightMessage}`}>
              <div className={`${styles.chatUserDetails}`}>
                <ChatRightInfo userDetails = {shareContact?.selectedsavedMsg?.fromDetails} isPopup={true}
                  timeStamp = {shareContact?.selectedsavedMsg?.timestamp} message={shareContact?.selectedsavedMsg}></ChatRightInfo>
                <ChatUserInfo userDetails = {shareContact?.selectedsavedMsg?.fromDetails} className='userinfoIcon rightSide'/>
              
              </div>
              <div className={styles.chatRightMessages}>
                <div className={styles.chatRight}>
                  <div className={styles.chatContent}>
                  <div className={styles.imageChat}>
                  <div className={styles.imageList}>
                      <div className={styles.imageSec}>
                        <video controls>
                          <source src={messageBody?.filePath} type="video/mp4"/>
                        </video></div>
                      </div>
                    </div>
                    {/* <ChatLike className='likeRight' placement="topRight"
                      tooltipTitle={data?.likeduserdetails} message={data}/> */}
                  </div>
                  <Tooltip title='Today at 12:13 PM' className='cusTooltip'
                    overlayClassName='customTooltip'><div className={styles.chatTime}>12:13</div></Tooltip>
                </div>
              </div>
            </div>}
            { shareContact?.selectedsavedMsg?.message?.messageType === 'FILE' && imageFormat.indexOf(messageBody.fileType) === -1 &&
             videoFormat.indexOf(messageBody.fileType) === -1 &&
              mp3Formats.indexOf(messageBody.fileType) === -1 &&
              <div className={`${styles.chatMsg} ${styles.rightMessage}`}>
                <div className={`${styles.chatUserDetails}`}>
                  <ChatRightInfo userDetails = {shareContact?.selectedsavedMsg?.fromDetails} isPopup={true}
                    timeStamp = {shareContact?.selectedsavedMsg?.timestamp} message={shareContact?.selectedsavedMsg}></ChatRightInfo>
                  <ChatUserInfo userDetails = {shareContact?.selectedsavedMsg?.fromDetails} className='userinfoIcon rightSide'/>
                </div>
                <div className={styles.chatRightMessages}>
                  <div className={styles.chatRight}>
                    <div className={styles.chatContent}>
                      <div className={styles.chatAttachmentList}>
                        <div className={styles.filesChat}>
                          <div className={styles.filesImage} >
                            {zipFormats.indexOf(messageBody.fileType) !== -1 ?
                              <img src={iconzip} alt="filename" />:
                              pdfFormats.indexOf(messageBody.fileType) !== -1 ?
                                <img src={iconpdf} alt="filename" />:
                                pptFormats.indexOf(messageBody.fileType) !== -1  ?
                                  <img src={iconppt} alt="filename" />:
                                  excelFormats.indexOf(messageBody.fileType) !== -1 ?
                                    <img src={iconxls} alt="filename" />:
                                    <img src={iconword} alt="filename" />
                            }</div>
                          <div className={styles.filesDetails}>
                            <Tooltip placement="top" title={messageBody.fileName} overlayClassName="tooltipCenter">
                              <span className={styles.fileName}>{
                                messageBody.fileName && messageBody.fileName.length > 25 ?
                                messageBody.fileName.substring(0, 25) + "..." : messageBody.fileName}</span>
                            </Tooltip>
                        <span className={styles.fileDt}>File Size:{getFileSize(fileDetails?.filesize)}</span>
                          </div>
                        </div>
                      </div>
                      {/* <ChatLike className='likeRight' placement="topRight"
                        tooltipTitle={data?.likeduserdetails} message={data}/> */}
                    </div>
                    <Tooltip title='Today at 12:13 PM' className='cusTooltip'
                      overlayClassName='customTooltip'><div className={styles.chatTime}>12:13</div></Tooltip>
                  </div>
                </div>
              </div>
            }
            {   shareContact?.selectedsavedMsg?.message?.messageType === 'FILE'  && mp3Formats.indexOf(messageBody.fileType) !== -1 &&
              <div className={`${styles.chatMsg} ${styles.rightMessage}`}>
                <div className={`${styles.chatUserDetails}`}>
                  <ChatRightInfo userDetails = {shareContact?.selectedsavedMsg?.fromDetails} isPopup={true}
                    timeStamp = {shareContact?.selectedsavedMsg?.timestamp} message={shareContact?.selectedsavedMsg}></ChatRightInfo>
                  <ChatUserInfo userDetails = {shareContact?.selectedsavedMsg?.fromDetails} className='userinfoIcon rightSide'/>
                </div>
                <div className={styles.chatRightMessages}>
                    <div className={styles.chatRight}>
                      <div className={styles.chatContent}>
                        <ChatAudioInner data={shareContact?.selectedsavedMsg}
                        userDetails = {shareContact?.selectedsavedMsg?.fromDetails}/>
                        {/* <ChatLike className='likeRight' placement="topRight"
                          tooltipTitle={data?.likeduserdetails} message={data}/> */}
                      </div>
                      <Tooltip title='Today at 12:13 PM' className='cusTooltip'
                        overlayClassName='customTooltip'><div className={styles.chatTime}>12:13</div></Tooltip>
                    </div>
                  </div>
              </div>
            }
       
            
                    </Modal>}
    </>
  );
} catch(e){
  return <p style={{color: 'red'}}>Something went wrong</p>;
}
};

